import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map, of, timer } from 'rxjs';

@Pipe({
    name: 'timeDelta',
    pure: true
})
export class TimeDeltaPipe implements PipeTransform {

    transform(value: any, roundToDay: boolean = false): Observable<string> {
        if (!value) {
            return of('');
        }

        if (value instanceof Date) {
            value = formatDate(value, 'yyyy-MM-ddTHH:mm:ss', 'en');
        }


        if (roundToDay) {

            return timer(0, 5000).pipe(
                map(() => {
                    const defaultUtcDate = new Date();
                    const utcDate = new Date(value);

                    const defaultDateWithHours = new Date(defaultUtcDate.getTime() + defaultUtcDate.getTimezoneOffset() * 60000);
                    const defaultDate = new Date(defaultDateWithHours.getFullYear(), defaultDateWithHours.getMonth(), defaultDateWithHours.getDate());
                    const date = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
                    const daysBetween = Math.floor((date.getTime() - defaultDate.getTime()) / (1000 * 60 * 60 * 24));
                    if (daysBetween === 0) {
                        return 'Today'
                    } else if (daysBetween === 1) {
                        return 'Tomorrow'
                    } else if (daysBetween === -1) {
                        return 'Yesterday'
                    } else if (daysBetween > 0) {
                        if (daysBetween >= 7) {
                            const weeksBetween = Math.floor(daysBetween / 7);
                            return `${weeksBetween} week${weeksBetween === 1 ? '' : 's'} from now`
                        }
                        return `${daysBetween} day${daysBetween === 1 ? '' : 's'} from now`
                    } else if (daysBetween < 0) {
                        if (daysBetween <= -365) {
                            const yearsBetween = Math.floor(Math.abs(daysBetween / 365));
                            return `${yearsBetween} year${yearsBetween === 1 ? '' : 's'} ago`
                        } else if (daysBetween <= -30) {
                            const monthsBetween = Math.floor(Math.abs(daysBetween / 30));
                            return `${monthsBetween} month${monthsBetween === 1 ? '' : 's'} ago`
                        } else if (daysBetween <= -7) {
                            const weeksBetween = Math.floor(Math.abs(daysBetween) / 7);
                            return `${weeksBetween} week${weeksBetween === 1 ? '' : 's'} ago`
                        }
                        return `${Math.abs(daysBetween)} day${daysBetween === 1 ? '' : 's'} ago`
                    }
                    return '';
                })
            )

        } else {

            return timer(0, 5000).pipe(
                map(() => {
                    if (value) {
                        const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
                        if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
                            return 'Just now';
                        const intervals: { [key: string]: number } = {
                            'year': 31536000,
                            'month': 2592000,
                            'week': 604800,
                            'day': 86400,
                            'hour': 3600,
                            'min': 60,
                            'second': 1
                        };
                        let counter;
                        for (const i in intervals) {
                            counter = Math.floor(seconds / intervals[i]);
                            if (counter > 0) {
                                if (counter === 1) {
                                    return counter + ' ' + i + ' ago'; // singular (1 day ago)
                                } else {
                                    return counter + ' ' + i + 's ago'; // plural (2 days ago)
                                }
                            }
                        }
                    }
                    return value;

                    // const utcDate = new Date(value);
                    // const date = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
                    // const futureLooking = (date.getTime() - new Date().getTime()) > 0;
                    // if (value) {

                    //     const seconds = futureLooking ? 
                    //         Math.floor((+new Date(value) - +new Date()) / 1000) :
                    //         Math.floor((+new Date() - +new Date(value)) / 1000);
                    //     if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
                    //         return futureLooking ? 'Very soon' : 'Just now';
                    //     const intervals: { [key: string]: number } = {
                    //         'year': 31536000,
                    //         'month': 2592000,
                    //         'week': 604800,
                    //         'day': 86400,
                    //         'hour': 3600,
                    //         'minute': 60,
                    //         'second': 1,
                    //     };
                    //     let counter;
                    //     for (const i in intervals) {
                    //         counter = Math.floor(seconds / intervals[i]);
                    //         if (counter > 0)
                    //             if(futureLooking){
                    //                 if (counter === 1) {
                    //                     return 'In ' + counter + ' ' + i; // singular (In 1 day)
                    //                 } else {
                    //                     return 'In ' + counter + ' ' + i + 's'; // plural (In 2 days)
                    //                 }
                    //             }else{
                    //                 if (counter === 1) {
                    //                     return counter + ' ' + i + ' ago'; // singular (1 day ago)
                    //                 } else {
                    //                     return counter + ' ' + i + 's ago'; // plural (2 days ago)
                    //                 }
                    //             }
                    //     }
                    // }
                    // return value;
                })
            )
        }

    }

}